import {
  ADD_ARCHIVES,
  ADD_NOTIFICATIONS,
  ADD_ROLES,
  ADD_USER,
  CLEAR_NOTIFICATIONS,
  REMOVE_NOTIFICATION,
  SET_ACTIVE,
  START_SESSION_POLLING,
  STOP_SESSION_POLLING,
  USER_LOGOUT
} from './action-types';

const initialState = {
  user: {
    id: 0,
    firstNames: 'Guest',
    callName: null,
    officialName: null,
    title: null,
    gender: 'male',
    validFrom: null,
    validTo: null,
    status: 'GUEST',
    organisation: null,
    contactInformation: null
  },
  roles: [],
  archives: [],
  notifications: [],
  sessionPolling: false,
  active: true
};

/**
 * Application reducer.
 * @param {Object} state
 * @param {String} action
 * @return {Object} the state.
 */
function appReducer(state = initialState, action) {
  // TODO change it to switch/case
  switch (action.type) {
    case ADD_USER:
      return Object.assign({}, state, {
        user: Object.assign({}, state.user, action.payload.user)
      });
    case ADD_ROLES:
      return Object.assign({}, state, {
        roles: [...state.roles, ...action.payload.roles]
      });
    case ADD_ARCHIVES:
      return Object.assign({}, state, {
        archives: [...state.archives, ...action.payload.archives]
      });
    case ADD_NOTIFICATIONS:
      return Object.assign({}, state, {
        notifications: [...state.notifications, ...action.payload]
      });
    case CLEAR_NOTIFICATIONS:
      return Object.assign({}, state, {
        notifications: state.notifications.slice(0, 0)
      });
    case REMOVE_NOTIFICATION:
      return Object.assign({}, state, {
        notifications: state.notifications.filter(function (item) {
          return item !== action.payload;
        })
      });
    case START_SESSION_POLLING:
      return {...state, sessionPolling: true};
    case STOP_SESSION_POLLING:
      return {...state, sessionPolling: false};
    case SET_ACTIVE:
      return {...state, active: action.payload};
    case USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export default appReducer;
